import { EVideoAspectRatio } from "../enum";
export const aspectRatioClassMap = {
    [EVideoAspectRatio.AspectRatio16x9]: "aspectRatio16x9",
    [EVideoAspectRatio.AspectRatio4x3]: "aspectRatio4x3",
};
export const getClassAndTitle = (value, warning, max) => {
    if (value >= max)
        return { className: "critical", title: "Критичне значення!" };
    if (value >= warning)
        return { className: "warning", title: "Попередження" };
    return { className: "", title: "" };
};
export const getClassAndTitleInverted = (value, warning, max) => {
    if (value <= max)
        return { className: "critical", title: "Критичне значення!" };
    if (value <= warning)
        return { className: "warning", title: "Попередження" };
    return { className: "", title: "" };
};
